import { ACCOUNT, GENERATE_OTP, USER_DETAILS_FIND_BY_EMAIL, VERIFY_OTP } from "./base.service";

export const generateOTP = async (source, isForNew = false, type = "phone") => {
    const data = await fetch(GENERATE_OTP , {
        body : JSON.stringify({
            source : source,
            type : type,
            isForNew : isForNew
        }),
        headers : {"Content-Type" : "application/json"},
        method : 'POST'
    })
    return data.json();
}

export const verifyOTP = async (OTP, source, type) => {
    const data = await fetch(VERIFY_OTP , {
        body : JSON.stringify({
            source : source,
            type : type,
            otp : OTP
        }),
        headers : {"Content-Type" : "application/json"},
        method : 'POST'
    })
    return data.json();
}

export const loginWithEmail = async (email, password) => {
    const data = await fetch(USER_DETAILS_FIND_BY_EMAIL , {
        body : JSON.stringify({
            email : email,
            password : password != null ? btoa(password) : null,
            loggedInFrom : password != null ? 'email' : 'google'
        }),
        headers : {"Content-Type" : "application/json"},
        method : 'POST'
    })
    return data.json();
}

export const registerWithEmailAndPassword = async (email, password) => {
    const data = await fetch(ACCOUNT + "/new" , {
        body : JSON.stringify({
            email : email,
            password : password != null ? btoa(password) : null,
            loggedInFrom : 'email'
        }),
        headers : {"Content-Type" : "application/json"},
        method : 'POST'
    })
    return data.json();
}

export const forgotPasswordAPI = async (email) => {
    const data = await fetch(ACCOUNT + "/forgotPassword" , {
        body : JSON.stringify({email : email}),
        headers : {"Content-Type" : "application/json"},
        method : 'POST'
    })
    return data.json();
}
export const resetPasswordAPI = async (email, password) => {
    const data = await fetch(ACCOUNT + "/resetPassword" , {
        body : JSON.stringify({email : email, password : btoa(password)}),
        headers : {"Content-Type" : "application/json"},
        method : 'POST'
    })
    return data.json();
}

// Clears the session and sends the user back to login. Used when the JWT is
// missing or the server rejects it with 401 (expired/invalid).
const forceLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    // Redirect explicitly to login rather than reloading the current (now
    // unauthenticated) route, which may not be guarded.
    document.location.href = "/login";
}

export const fetcher = async (
    url,
    method,
    body,
    contentType = "application/json",
    extraHeaders = {}
) => {
    let token = sessionStorage.getItem("token");
    if(!token){
        console.error("Invalid Token");
        forceLogout();
        return;
    }

    const headers = {
        "Content-Type" : contentType,
        "Authorization" : `Bearer ${token}`,
        ...extraHeaders
    }
    const options = {
        body : null,
        method : method,
        headers : headers
    }
    if(contentType === "application/json" && body){
        options.body = JSON.stringify(body)
    }
    else if(contentType === "multipart/form-data" && body instanceof FormData){
        if(options.headers){
            delete options.headers["Content-Type"];
        }
        options.body = body;
    }

    let response = (await fetch(`${url}`, options))

    // 401 => token missing/invalid/expired: treat as session-expired.
    if(response?.status === 401){
        console.log("Session Expired");
        forceLogout();
        return
    }
    // 403 => tried to access another user's resource. Should never happen in a
    // normal UI flow. Surface a generic "no access" toast globally (via a window
    // event that App listens for) and DO NOT log the user out or retry. The
    // Response is still returned so callers can safely read its JSON body
    // ({status:false, message:"Forbidden"}) without crashing.
    if(response?.status === 403){
        console.warn("Forbidden: attempted to access a resource you don't own");
        window.dispatchEvent(new CustomEvent("api:forbidden"));
        return response
    }
    return response
}